/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import wavesImg from 'assets/images/waves.svg';
import IconApi from 'assets/images/imagem-api.svg';
import createTrack from 'services/actions/tracker_actions';
import { ApiRequestStatusInfo, getApiRequestStatus } from 'services/conlicitacao_api_request';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';

const DOCS_PATH = '/conlicitacao_api/solicitar';

const ConlicitacaoApi = () => {
  const history = useHistory();
  const [serverStatus, setServerStatus] = useState<ApiRequestStatusInfo | null>(null);
  const [statusLoaded, setStatusLoaded] = useState<boolean>(false);

  useEffect(() => {
    createTrack('Acessou API ConLicitação', {});
    document.title = 'API Conlicitação - ConLicitação';
  }, []);

  useEffect(() => {
    let active = true;
    getApiRequestStatus()
      .then((info) => {
        if (active) setServerStatus(info);
      })
      .catch(() => {
        if (active) setServerStatus(null);
      })
      .finally(() => {
        if (active) setStatusLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  const emFluxo = Boolean(serverStatus);

  return (
    <Container>
      <div className="container p-4 mt-5">
        <div className="row">
          <div className="col-12">
            <div className={`card card-shadow p-3 p-md-4 `}>
              <div className="active-services-bg">
                <div className="row align-items-center m-0">
                  <div className="col-12 col-md-6">
                    <h4 className="mb-0 px-md-3 px-4 py-md-0 py-5">
                      Melhore sua experiência com o ConLicitação através dos nossos novos serviços
                    </h4>
                  </div>
                  <div className="col-12 col-md-6 p-0">
                    <div className="active-services-wave">
                      <img className="active-services-wave-img d-none d-lg-block" src={wavesImg} />
                      <div className="active-services-wave-bg">
                        <h4 className="text-white mb-0">
                          Integre seu sistema com as informações do boletim ConLicitação
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-12 col-md-6 mt-4 mt-md-0 text-center">
                  <img className="" src={IconApi} />
                </div>
                <div className="col-12 col-md-6 mt-5">
                  <h4 className="text-center mb-3 font-weight-bold">API ConLicitação</h4>
                  <p>
                    A API ConLicitação foi criada para dar suporte aos clientes que necessitam
                    integrar as informações dos boletins com seus ERPs, CRMs, sistemas de
                    gerenciamento de licitações e outros softwares de gestão de terceiros.{' '}
                  </p>
                  <p>
                    Trata-se de uma API REST criada para facilitar o acesso aos dados de cada um dos
                    filtros dos clientes de forma segura e organizada.{' '}
                  </p>
                  <p> Através da API sua empresa contará com as seguintes facilidades: </p>
                  <ul className="list-with-check mt-2 mb-4">
                    <li>
                      <span className="oi oi-check pr-2" />
                      Integração com softwares de terceiros.
                    </li>
                    <li>
                      <span className="oi oi-check pr-2" />
                      Acesso automático a todos os filtros e boletins.
                    </li>
                    <li>
                      <span className="oi oi-check pr-2" />
                      Tratamento dos avisos de licitação e acompanhamento de acordo com as regras de
                      negócio do cliente.
                    </li>
                  </ul>
                  {!statusLoaded ? (
                    <button
                      type="button"
                      className="mt-3 btn btn-primary btn-lg btn-block"
                      disabled
                    >
                      Carregando…
                    </button>
                  ) : emFluxo ? (
                    <button
                      type="button"
                      className="mt-3 btn btn-primary btn-lg btn-block"
                      onClick={() => history.push('/conlicitacao_api/solicitacao')}
                    >
                      Acompanhar solicitação
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="mt-3 btn btn-primary btn-lg btn-block"
                      onClick={() => history.push(DOCS_PATH)}
                    >
                      Solicitar acesso à API
                    </button>
                  )}
                  {statusLoaded && (
                    <button
                      type="button"
                      className="mt-2 btn btn-outline-secondary btn-lg btn-block"
                      onClick={() => {
                        openSupportChat();
                      }}
                    >
                      Fale com um consultor
                    </button>
                  )}
                  <span className="mt-2">
                    Se preferir entre em contato conosco pelo telefone e whatsapp +55 (11) 3789-9102
                    ou pelo e-mail
                  </span>
                  <a href="mailto:comercial@conlicitacao.com.br" className="text-center">
                    comercial@conlicitacao.com.br
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ConlicitacaoApi;
